{
  "title": "Compte",
  "description": "Gérez votre profil et votre identité sur la plateforme.",
  "profileTitle": "Profil",
  "profileDescription": "Votre nom et votre e-mail. L'enregistrement d'un nom prend effet immédiatement ; un changement d'e-mail est confirmé par un lien envoyé à la nouvelle adresse.",
  "firstNameLabel": "Prénom",
  "lastNameLabel": "Nom",
  "emailLabel": "Adresse e-mail",
  "emailHint": "Utilisée pour la connexion et les notifications du compte.",
  "save": "Enregistrer les modifications",
  "sendVerification": "Envoyer le lien de vérification",
  "saved": "Enregistré",
  "savedDescription": "Votre profil a été mis à jour.",
  "saveError": "Nous n'avons pas pu enregistrer vos modifications.",
  "saveErrorDescription": "Réessayez et, si le problème persiste, contactez le support.",
  "emailSent": "Vérifiez votre boîte de réception",
  "emailSentDescription": "Nous avons envoyé un lien à {{email}} pour confirmer le changement.",
  "emailError": "Nous n'avons pas pu démarrer le changement d'e-mail.",
  "emailUnchanged": "C'est déjà votre adresse e-mail.",
  "identityTitle": "Identité",
  "identityDescription": "Votre statut et vos rôles sur ce compte.",
  "statusLabel": "Statut du compte",
  "rolesLabel": "Rôles",
  "tenantLabel": "Organisation",
  "platformTenant": "Plateforme",
  "validation": {
    "firstNameRequired": "Saisissez votre prénom.",
    "lastNameRequired": "Saisissez votre nom.",
    "nameTooLong": "Utilisez 100 caractères ou moins.",
    "emailRequired": "Saisissez une adresse e-mail.",
    "emailInvalid": "Saisissez une adresse e-mail valide."
  }
}
